import {createElement, Component, PropTypes} from 'rlink-react';
import css from 'static/style/dow.less';
import connectToPathForContent from 'rlink-repos/connectToPathForContent';


function ArticleBody ({bodyHtml, pathForContent}) {
  let parsed = bodyHtml;
  let matchAll = bodyHtml.match(/.*?src="(\/content\/.*?)"/g);
  if (matchAll) {
    for (let i = 0; i < matchAll.length; i++) {
      let match = matchAll[i].match(/.*?src="(\/content\/.*?)"/);
      parsed = parsed.replace(match[1], pathForContent(match[1]));
    }
  }
  return <div className={css['article-body']}
    dangerouslySetInnerHTML={{__html: parsed}} />;
}

ArticleBody.propTypes = {
  bodyHtml: PropTypes.string,
  pathForContent: PropTypes.func,
};

export default connectToPathForContent(ArticleBody);



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/components/article-body.jsx